export const Currency = {
    DE: 'EUR',
    PL: 'PLN',
    HU: 'HUF',
    RO: 'RON'
} as const;
